const common = {
  siteName: '岛国精品',
  siteSlogan: '日本原装进口，正品直邮到家',
  navHome: '首页',
  navCategory: '全品类专区',
  navArticles: '精选文章',
  navAbout: '关于我们',
  navContact: '联系我们',
  footerRights: '© 2026 岛国精品 版权所有',
  footerPrivacy: '隐私政策',
  footerTerms: '服务条款',
  footerSitemap: '网站地图',
  breadcrumbHome: '首页',
  scrollToTop: '回到顶部',
  loading: '加载中...',
  viewMore: '查看更多',
  viewAll: '查看全部',
  backToList: '返回列表',
  prevPage: '上一页',
  nextPage: '下一页',
  contactUs: '联系我们',
  subscribeNewsletter: '订阅资讯',
  subscribePlaceholder: '输入您的邮箱地址',
  subscribeButton: '订阅',
  subscribeSuccess: '订阅成功！感谢您的关注。',
  subscribeError: '订阅失败，请稍后重试。',
  readMore: '阅读全文',
  publishedOn: '发布于',
  categoryLabel: '分类',
  tagLabel: '标签',
  shareLabel: '分享',
  relatedArticles: '相关文章',
  phoneLabel: '电话',
  emailLabel: '邮箱',
  addressLabel: '地址',
  wechatLabel: '微信公众号',
  workingHours: '工作时间',
};

export default common;